// 英语
import en from '../JsonLang/en.json'
import enSpec from '../JsonLangSpec/en.json'
export const lang = {
  ...en, ...enSpec
}
